/* --------------------------- Config & Constants --------------------------- */

const KUJI_ASSET_URL = 'https://cdn.shopify.com/s/files/1/0728/0410/6425/files/';
const RAF_ASSET_URL  = 'https://cdn.shopify.com/s/files/1/0650/2019/9164/files/';

const KUJI_MIN_CENTS = 5000;   // $50.00
const KUJI_MAX_CENTS = 300000; // $3,000

const SUPPORTED_CURRENCIES = new Set(['NZD','USD','CAD','GBP','EUR','AUD']);

let kujiStatus = typeof window.kuji_status !== "undefined" && window.kuji_status === "ACTIVE";
const kujiMerchant     = typeof window.kuji_merchant !== 'undefined' && window.kuji_merchant ? String(window.kuji_merchant) : '';
const merchantHandle   = kujiMerchant.toLowerCase().replace(/ /g, '-');
const kujiMedia        = Array.isArray(window.kuji_media) ? window.kuji_media : [];

const kujiSearchParams = new URLSearchParams(window.location.search);
const kujiPreview = Object.fromEntries(kujiSearchParams.entries());

const isDesignMode = !!(window.Shopify && window.Shopify.designMode);

/* ------------------------------ Cookies ---------------------------------- */

const Cookies = {
  get: (name) => document.cookie
    .split(';')
    .map(s=>s.trim())
    .find(c => c.startsWith(name+'='))?.split('=')[1] || '',
  set: (name, value, days=30) => {
    const d = new Date(Date.now() + days*864e5).toUTCString();
    document.cookie = `${name}=${value}; expires=${d}; path=/; SameSite=Lax`;
  },
  delete: (name) => {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax`;
  }
};

function kujiAttributionSource() {
  return Cookies.get('kuji-preview') == 'true' ? 'a' : 'm';
}

/* ----------------------- Third-party guards/helpers ----------------------- */

const safeMP = (name, props) => { try { window.mixpanel?.track?.(name, props); } catch(_){} };
const safeGAEvent = (action, label) => {
  try { window.ga?.('send', { hitType:'event', eventCategory:'kuji', eventAction:action, eventLabel:label }); } catch(_){}
  try { window.gtag?.('event','kuji',{ Action:action, Label:label }); } catch(_){}
};

/* ---------------------------- Currency & X copy --------------------------- */

const kujiCartCurrency = (Cookies.get('cart_currency') || '').toUpperCase();

const kujiXRaw = (typeof window.kuji_x !== 'undefined' && window.kuji_x !== '') ? String(window.kuji_x) : '3';
const KUJI_X = kujiXRaw.includes('%')
  ? { type: 'percent', value: parseFloat(kujiXRaw) }  // e.g. "22.5%" -> 22.5
  : { type: 'multiplier', value: Number(kujiXRaw) || 3 };

const kujiXText = (() => {
  if (KUJI_X.type === 'multiplier') {
    if (KUJI_X.value === 3) return 'triple';
    if (KUJI_X.value > 3)   return `${KUJI_X.value} times`;
    return 'double';
  }
  return KUJI_X.value >= 22.5 ? 'a 20%-50%' : 'a 10%-30%';
})();

const kujiWinRatio = String(window.kuji_win_ratio || '50'); // '50' or '60'

/* -------------------------- Popup asset selection ------------------------- */

let popupBg = kujiMedia.find(u => u.includes('-primary_'))?.replace('_2048x', '_1000x')
           || 'https://cdn.shopify.com/s/files/1/0650/2019/9164/files/merchant-raflin-card_800x.jpg?v=1698100225';
const popupIcon = 'https://cdn.shopify.com/s/files/1/0728/0410/6425/files/KUJI_Icon_Lilac.png?v=1757369917';

const kujiButtonText = typeof window.kuji_button_text !== 'undefined' ? String(window.kuji_button_text) : 'BUY';
const KujiLogoSmall = `${RAF_ASSET_URL}kuji_logo_60x.png`; // 60x small logo for buttons


/* ----------------------------- AB Assignment ----------------------------- */

function ensureABAssigned() {
  if (kujiPreview.kuji === 'true') {
    kujiStatus = true
    Cookies.set('kuji-ab', '1');
    Cookies.set('kuji-preview', 'true');
    return;
  }

  let ab = Cookies.get('kuji-ab');
  if (ab === '' && kujiStatus) {
    const p = (typeof window.kuji_ab === 'number' && window.kuji_ab >= 0 && window.kuji_ab <= 1) ? window.kuji_ab : 1;
    ab = Math.random() < p ? '1' : '0';
    Cookies.set('kuji-ab', ab, 30);
    safeMP('A/B Split', { Action:'Test Assigned', Value: ab==='1'?'With kuji':'Without kuji', Merchant: merchantHandle });
  }
}
ensureABAssigned();

/* ----------------------------- Mixpanel init ----------------------------- */

(function initMixpanel() {
  if (typeof window.kuji_tracking_id === 'undefined') return;
  if (window.__kuji_mp_init__) return;
  window.__kuji_mp_init__ = true;

  (function (f, b) { if (!b.__SV) { var e, g, i, h; window.mixpanel = b; b._i = []; b.init = function (e, f, c) { function g(a, d) { var b = d.split("."); 2 == b.length && ((a = a[b[0]]), (d = b[1])); a[d] = function () { a.push([d].concat(Array.prototype.slice.call(arguments, 0))); }; } var a = b; "undefined" !== typeof c ? (a = b[c] = []) : (c = "mixpanel"); a.people = a.people || []; a.toString = function (a) { var d = "mixpanel"; "mixpanel" !== c && (d += "." + c); a || (d += " (stub)"); return d; }; a.people.toString = function () { return a.toString(1) + ".people (stub)"; }; i = "disable time_event track track_pageview track_links track_forms track_with_groups add_group set_group remove_group register register_once alias unregister identify name_tag set_config reset opt_in_tracking opt_out_tracking has_opted_in_tracking has_opted_out_tracking clear_opt_in_out_tracking start_batch_senders people.set people.set_once people.unset people.increment people.append people.union people.track_charge people.clear_charges people.delete_user people.remove".split(" "); for (h = 0; h < i.length; h++) g(a, i[h]); var j = "set set_once union unset remove delete".split(" "); a.get_group = function () { function b(c) { d[c] = function () { call2_args = arguments; call2 = [c].concat(Array.prototype.slice.call(call2_args, 0)); a.push([e, call2]); }; } for ( var d = {}, e = ["get_group"].concat( Array.prototype.slice.call(arguments, 0)), c = 0; c < j.length; c++) b(j[c]); return d; }; b._i.push([e, f, c]); }; b.__SV = 1.2; e = f.createElement("script"); e.type = "text/javascript"; e.async = !0; e.src = "undefined" !== typeof MIXPANEL_CUSTOM_LIB_URL ? MIXPANEL_CUSTOM_LIB_URL : "file:" === f.location.protocol && "//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js".match(/^\/\//) ? "https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js" : "//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js"; g = f.getElementsByTagName("script")[0]; g.parentNode.insertBefore(e, g); } })(document, window.mixpanel || []);
  try { window.mixpanel.init(window.kuji_tracking_id, { debug:true, track_pageview:false, persistence:'localStorage' }); } catch(_){}
})();

/* ------------------------------- FX Helpers ------------------------------- */

function fadeIn(element, display) {
  if (!element) return;
  let op = 0.1;
  element.style.display = display;
  element.style.opacity = '0';
  const timer = setInterval(() => {
    if (op >= 1) { clearInterval(timer); op = 1; }
    element.style.opacity = String(op);
    op += op * 0.1;
  }, 10);
}

function fadeOut(element) {
  if (!element) return;
  let op = 1;
  const timer = setInterval(() => {
    if (op <= 0.1) {
      clearInterval(timer);
      element.style.display = 'none';
      element.style.opacity = '0';
      return;
    }
    element.style.opacity = String(op);
    op -= op * 0.1;
  }, 10);
}

function setTextAllIn(sel, val) {
  document.querySelectorAll(sel).forEach(el => el.textContent = String(val));
}

/* ----------------------------- Product CTA Variants ----------------------------- */

const PRODUCT_CTA_VARIANTS = [
  'win_with_kuji',
  'win_for_price',
  'kuji_for_price',
];

function formatTicketPrice(ticketValue) {
  return ticketValue < 30 ? ticketValue.toFixed(2) : String(ticketValue);
}

function getNearestProductForm(el) {
  let node = el;
  while (node && node !== document.documentElement) {
    if (node.matches && node.matches('form[action*="/cart/add"]')) return node;
    node = node.parentElement;
  }
  return null;
}

function getSelectedVariantId(form) {
  if (!form) return null;

  const input =
    form.querySelector('input[name="id"]') ||
    form.querySelector('select[name="id"]');

  if (!input || !input.value) return null;
  return String(input.value);
}

function getNearestQuantityInput(button, form = null) {
  // Get qty input in current product form
  const selectors = 'input[name="quantity"], select[name="quantity"]';
  const quantityInput = form?.querySelector(selectors);
  if (quantityInput) return quantityInput;

  // If qty input is outside of the form, we'll keep checking parents to find closest input
  let node = form?.parentElement || button?.parentElement;
  while (node && node !== document.documentElement) {
    const input = node.querySelector?.(selectors);
    if (input) return input;
    node = node.parentElement;
  }

  return null;
}

function getSelectedQuantity(button, form) {
  const input = getNearestQuantityInput(button, form);
  if (!input) return 1;

  const quantity = Number(input?.value || 1);

  if (!Number.isFinite(quantity) || quantity <= 0) return 1;
  return quantity;
}

function getKujiProductVariantById(variantId) {
  const variants = Array.isArray(window.kuji_product?.variants)
    ? window.kuji_product.variants
    : [];

  return variants.find((variant) => String(variant.id) === String(variantId)) || null;
}

function canUseProductCtaExperiment(button) {
  const form = getNearestProductForm(button);

  const selectedVariantId =
    getSelectedVariantId(form) ||
    (window.kuji_product?.selectedVariantId ? String(window.kuji_product.selectedVariantId) : null);

  if (!selectedVariantId) return null;

  const variant = getKujiProductVariantById(selectedVariantId);
  if (!variant) return null;

  const quantity = getSelectedQuantity(button, form);
  const priceCents = Number(variant.price || 0) * quantity;
  if (!priceCents) return null;

  const calc = calculateTicket(priceCents);
  if (!calc?.widgetsEnabled) return null;

  return {
    form,
    selectedVariantId,
    quantity,
    variant,
    calc,
  };
}


function resetProductButton(button) {
  if (!button) return;

  button.dataset.kujiCtaReady = 'false';
  delete button.dataset.kujiMessageVariant;
  delete button.dataset.kujiTicketPrice;
  delete button.dataset.kujiVariantId;
  delete button.dataset.kujiQuantity;

  button.innerHTML = `
    <span class="buy-now">WIN IT NOW</span> <span class="small-with">with</span>
    <img loading="lazy" width="28" height="12" src="${KujiLogoSmall}" alt="kuji logo">
  `;
}

function updateProductButton(button) {
  if (!button) return;

  const context = canUseProductCtaExperiment(button);

  //console.log('context',context)
  if (!context) {
    resetProductButton(button);
    return;
  }

  if (!button.dataset.kujiMessageVariant) {
    const index = Math.floor(Math.random() * PRODUCT_CTA_VARIANTS.length);
    button.dataset.kujiMessageVariant = PRODUCT_CTA_VARIANTS[index];
  }

  const variantKey = button.dataset.kujiMessageVariant;
  const ticketPrice = formatTicketPrice(context.calc.ticket);

  button.dataset.kujiCtaReady = 'true';
  button.dataset.kujiTicketPrice = ticketPrice;
  button.dataset.kujiVariantId = context.selectedVariantId;
  button.dataset.kujiQuantity = String(context.quantity);

  if (variantKey === 'win_with_kuji') {
    button.innerHTML = `
      <span class="buy-now">WIN IT NOW</span> <span class="small-with">with</span>
      <img loading="lazy" width="28" height="12" src="${KujiLogoSmall}" alt="kuji logo">
    `;
    return;
  }

  if (variantKey === 'win_for_price') {
    button.innerHTML = `
      <span class="buy-now">WIN IT NOW</span> <span class="small-with">for</span>
      $<span class="kuji-price">${ticketPrice}</span>
    `;
    return;
  }

  button.innerHTML = `
    <span class="buy-now">KUJI IT NOW</span> <span class="small-with">for</span>
    $<span class="kuji-price">${ticketPrice}</span>
  `;
}

/* ----------------------------- Cart Utilities ----------------------------- */

async function getCart() {
  const base = (window.Shopify?.routes?.root || '/');
  const res = await fetch(`${base}cart.js`, { credentials: 'same-origin' });
  if (!res.ok) throw new Error(`cart.js ${res.status}`);
  return res.json();
}

/* ------------------------- Ticket Price Calculator ------------------------ */

function customCeil(num, digits) {
  const factor = 10 ** digits;
  return Math.ceil(num * factor) / factor;
}

// Returns: { ticket: number (dollars), minCartCents: number, widgetsEnabled: boolean, percentCopy: string }
function calculateTicket(cartTotalCents) {
  // Effective 5% product/cart price
  let WR = 20;
  // $500 should use 2.5% WR
  if (kujiWinRatio === '60' || cartTotalCents > 50000 ) {
    WR = 40;
  }

  let ticketDollars = customCeil((cartTotalCents / (WR * 100) + 1), 1);
  if (ticketDollars > 9.99 && ticketDollars <= 30) ticketDollars = Math.ceil(ticketDollars * 2) / 2;
  else if (ticketDollars > 30 && ticketDollars <= 99) ticketDollars = Math.ceil(ticketDollars);
  else if (ticketDollars > 99 && ticketDollars <= 500) ticketDollars = 5 * Math.ceil(ticketDollars / 5);

  if (cartTotalCents > KUJI_MAX_CENTS) return { widgetsEnabled:false };

  const relief = (ticketDollars < 10) ? (WR/10) : (ticketDollars <= 30 ? (WR/2) : WR);
  const minCartCents = Math.max(0, Math.round(((ticketDollars * WR) - relief) * 100));

  const percentCopy = (KUJI_X.type === 'percent')
    ? (KUJI_X.value >= 22.5 ? 'a 20%-50%' : 'a 10%-30%')
    : `a ${5 * KUJI_X.value}%`;

  return { ticket: ticketDollars, minCartCents, widgetsEnabled:true, percentCopy };
}

/* --------------------------- Kuji URL Builder ----------------------------- */

function buildKujiUrl(cart) {
  const localeMap = { NZD:'en-nz', USD:'en-us', CAD:'en-ca', GBP:'en-gb', EUR:'en-eu', AUD:'' };
  const geo = localeMap[kujiCartCurrency] || '';
  const base = new URL(`https://kujinow.com/${geo ? geo + '/' : ''}cart`);

  const items = cart.items.map(it => `${it.variant_id}:${it.quantity}`).join(',');
  const products = cart.items.map(it => it.title.replaceAll(',', '')).join(',');

  const x = String(KUJI_X.value); // multiplier or percent number (no % symbol)

  base.search = new URLSearchParams({
    h: Shopify.shop.replace('.myshopify.com',''),
    m: kujiMerchant,
    t: String(cart.total_price),  // cents
    s: kujiAttributionSource(),
    x,
    r: kujiWinRatio,
    i: items,
    p: products
  }).toString();

  return base.toString();
}

/* ------------------------------ Popup HTML ------------------------------- */

const RafLogo = `
  <img loading="lazy" width="200" height="51"
       src="${RAF_ASSET_URL}kuji_logo_200x.png" alt="kuji logo"/>
`;
const RafPoweredLogo = `
  <img loading="lazy" width="200" height="111"
       src="${KUJI_ASSET_URL}kuji_powered_logo_200x.png" alt="kuji powered"/>
`;
const RafFooter = `
  <div class="kuji-footer">
    <a class="kuji-footer-logo" href="https://www.kujinow.com" target="_blank" rel="noopener">${RafPoweredLogo}</a>
  </div>
`;
const RafGeneralInfo = `<p class="explain">Or ${kujiXText} your money back in store credit INSTANTLY</p>`;
const POPUP_VARIANTS = [
  'popup_with_cart_summary',
  'popup_without_cart_summary',
];

const RafSteps = `
  <div class="kuji-popup-steps">
    <div class="show-mobile">
      <h5>1 in ${kujiWinRatio} win the cart</h5>
      <p>Everyone else wins ${kujiXText} your ticket price in store credit, win-win.</p>
    </div>
    <ul>
      <li class="kuji-step">
        <div class="step-img show-mobile">
          <img class="show-mobile" loading="lazy" width="300" height="300"
               src="${RAF_ASSET_URL}icon-shopping_cart_small.png" alt="kuji step 1">
        </div>
        <h4>Step 1</h4><h5>Shop</h5>
        <p>Shop as you always do!<br/>Add your favourite items<br/> to the cart.</p>
        <div class="kuji-step-tag">COMPLETED<span><div class="kuji-check-icon"></div></span></div>
      </li>
      <li class="kuji-step kuji-step-2">
        <div class="step-img show-mobile">
          <img class="show-mobile" loading="lazy" width="300" height="300"
               src="${RAF_ASSET_URL}icon-click_small.png" alt="kuji step 2">
        </div>
        <h4>Step 2</h4><h5>Click</h5>
        <div class="kuji-btn kuji-brand-btn kuji-example">
          <span class="buy-now">${kujiButtonText}</span> <span class="small-with">with</span>${RafLogo}
        </div>
        <p>Click <b>“${kujiButtonText}”</b><br/> at the cart section and<br/> buy a ticket.</p>
        <div class="kuji-step-tag">PENDING<span>•••</span></div>
        <img class="kuji-you-are-here" loading="lazy" src="${RAF_ASSET_URL}you-are-here_400x.png" alt="you are here">
      </li>
      <li class="kuji-step kuji-step-3">
        <div class="step-img show-mobile">
          <img loading="lazy" width="300" height="300"
               src="${RAF_ASSET_URL}icon-card_small.png" alt="kuji step 3">
        </div>
        <h4>Step 3</h4><h5>Win <span>Instantly</span></h5>
        <p>Your <b>ENTIRE CART</b><br/>or <br/><b>${kujiXText}</b> your<br/> ticket value back.</p>
        <div class="kuji-step-tag">INSTANTLY</div>
      </li>
    </ul>
  </div>
`;

/* ---------------------------- UI Construction ----------------------------- */

let kujiPopupEl, kujiPromoEl, kujiInfoEl, kujiHIWEl;
let kujiPopupInit = false;

function ensurePopupVariant() {
  if (!kujiPopupEl) return null;
  if (!kujiPopupEl.dataset.kujiPopupVariant) {
    const index = Math.floor(Math.random() * POPUP_VARIANTS.length);
    kujiPopupEl.dataset.kujiPopupVariant = POPUP_VARIANTS[index];
  }
  return kujiPopupEl.dataset.kujiPopupVariant;
}

function applyPopupVariant() {
  if (!kujiPopupEl) return;

  const popupVariant = ensurePopupVariant();
  const cartSummaryCard = kujiPopupEl.querySelector('.kuji-popup-summary-card');
  if (!cartSummaryCard) return;

  cartSummaryCard.style.display = popupVariant === 'popup_without_cart_summary' ? 'none' : '';
}

function buildMainPopup() {
  if (kujiPopupInit) return;
  kujiPopupEl = document.createElement('div');
  kujiPopupEl.id = 'kuji-popup';
  kujiPopupEl.className = 'kuji-popup';

  const prizeLine = `
    <div class="winning-options">
      <ul>
        <li><p>1 in ${kujiWinRatio} chance of <strong>INSTANTLY</strong> winning <br/>your entire ${kujiMerchant} purchase.</p></li>
        <li><p>Or unlock <span class="kuji-cart-value"></span> OFF <br/>discount — <strong>Everyone WINS!</strong></p></li>
      </ul>
    </div>`;

  kujiPopupEl.innerHTML = `
    <div class="kuji-popup-inner">
      <button type="button" class="close-kuji-popup-x" data-kuji-close="main"></button>
      <div id="kuji-popup-content" class="popup-content">
        <div class="kuji-card-details">
          <img loading="lazy" class="kuji-merchant-logo" width="50" height="50" alt="${kujiMerchant} kuji logo" src="${popupIcon}" />
          <div class="kuji-card-details-info">
            <p><strong>${kujiMerchant}</strong></p>
            <div class="kuji-card-specs"><p>Limited time offer</p></div>
          </div>
        </div>
        <div class="kuji-feature-img">
          <img class="kuji-popup-feature-img" src="${popupBg}" alt="">
          <div class="kuji-popup-content">
            <div class="kuji-relative">
              <div class="kuji-blur"></div>
              <h5><b>WIN Your Cart</b> for $<span class="kuji-price"></span></h5>
            </div>
          </div>
        </div>
        <div class="kuji-popup-padding kuji-min-cart">
          <div class="kuji-popup-card">
            <a class="kuji-buy-ticket kuji-btn kuji-brand-btn" href="#" target="_blank" rel="noopener">
              <span>WIN IT NOW</span> <span class="small-with">with</span>${RafLogo}
            </a>
            ${prizeLine}
          </div>

          <div class="kuji-popup-card kuji-secondary-prize">${prizeLine}</div>
          <div class="kuji-popup-card kuji-popup-summary-card">
           <div class="kuji-popup-cart-summary"></div>
           <div class="kuji-popup-cart-total">
            <span>Total:</span>
            <span>$<span class="kuji-cart-total"></span></span>
           </div>
           <a class="kuji-buy-ticket kuji-btn kuji-brand-btn" href="#" target="_blank" rel="noopener">
             <span>WIN IT NOW</span> <span class="small-with">for</span> $<span class="kuji-price"></span>
           </a>
          </div>

        </div>
        ${RafSteps}${RafFooter}
      </div>
    </div>
  `;
  document.body.appendChild(kujiPopupEl);
  applyPopupVariant();
  kujiPopupInit = true;
}

/* --------------------------- Gating & Core Flow --------------------------- */



// Update and re-render Kuji Popup
async function updateKuji({ prevTotal = null } = {}) {
  try {
    const cart = await getCart(); // { total_price, items, ... }
    const total = Number(cart?.total_price || 0);

    // If we passed a snapshot and total hasn’t changed yet, keep polling forever (500ms)
    if (typeof prevTotal === 'number' && !Number.isNaN(prevTotal) && total === prevTotal) {
      setTimeout(() => updateKuji({ prevTotal }), 500);
      return;
    }

    //console.log('cart',cart)

    // Proceed with UI updates once total changed (or if no prevTotal was provided)
    const calc = calculateTicket(total);
    if (!calc.widgetsEnabled) return;

    const ticketStr = calc.ticket < 30 ? calc.ticket.toFixed(2) : String(calc.ticket);

    setTextAllIn('.kuji-price', ticketStr);
    setTextAllIn('.kuji-cart-value', calc.percentCopy);
    setTextAllIn('.kuji-min-spend', (calc.minCartCents / 100).toFixed(0));
    setTextAllIn('.kuji-cart-total', (total / 100).toFixed(2) );
    // Cart summary
    const html = cart.items.map(item => {
      const image = item.featured_image?.url || '';
      const title = item.product_title || item.title;
      const variant = item.variant_title ? `<div class="variant">${item.variant_title}</div>` : '';
      const price = (item.final_line_price / 100).toFixed(2);

      return `
        <div class="kuji-cart-line" data-key="${item.key}">
          <img class="kuji-cart-line-thumb" src="${image}" alt="${title}">
          <div class="kuji-cart-line-info">
            <div class="kuji-cart-line-title">${title}<span class="kuji-cart-line-variant">${variant}</span></div>
            <div class="kuji-cart-line-qty">
              <button type="button" class="kuji-cart-line-minus"></button>
              <input type="text" value="${item.quantity}"/>
              <button type="button" class="kuji-cart-line-add"></button>
            </div>
          </div>
          <div class="kuji-cart-line-price">$${price}</div>
        </div>
      `;
    }).join('');

    // Inject cart summary into popup container
    document
    .querySelectorAll('.kuji-popup-cart-summary')
    .forEach(el => { el.innerHTML = html; });

    // Always refresh the Kuji URL
    const buttons = document.querySelectorAll('.kuji-buy-ticket');
    buttons.forEach(btn => {
      btn.setAttribute('href', buildKujiUrl(cart));
    });

    // Show popup if above minimum
    if (total >= KUJI_MIN_CENTS) {
      if (typeof kujiPopupEl !== 'undefined' && kujiPopupEl) {
        fadeIn(kujiPopupEl, 'flex');
      }
      return;
    }

    // If we *didn’t* pass prevTotal (no recent add), you can keep the original alerts
    if (prevTotal == null) {
      if (total === 0) {
        alert("Error adding product to cart. Make sure it’s in stock.");
        return;
      }
      alert(`$${(KUJI_MIN_CENTS / 100).toFixed(0)} minimum cart required for kuji`);
    }
    // If prevTotal was given and we got here, the total changed but is still below min — no alert by default.

  } catch (err) {
    console.error('updateKuji failed:', err);
  }
}

// Quantity change on Kuji Popup cart summary:
async function updateCartLine(key, quantity) {
  // Find the line element in the DOM
  const lineEl = document.querySelector(`.kuji-cart-line[data-key="${key}"]`);
  const priceEl = lineEl?.querySelector('.kuji-cart-line-price');

  // Add loading state
  if (priceEl) {
    priceEl.classList.add('loading');
    priceEl.dataset.original = priceEl.textContent; // optional backup
    priceEl.textContent = '';
  }

  // Send update to Shopify
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({ id: key, quantity })
  });

  // Refresh the entire Kuji popup (this will remove loading state)
  await updateKuji();
}

// Kuji Popup Cart Summary Qty adjust:

// +/- buttons
document.addEventListener('click', async (e) => {
  const minus = e.target.closest('.kuji-cart-line-minus');
  const add   = e.target.closest('.kuji-cart-line-add');
  if (!minus && !add) return;

  const lineEl = e.target.closest('.kuji-cart-line');
  if (!lineEl) return;

  const key   = lineEl.dataset.key;
  const input = lineEl.querySelector('.kuji-cart-line-qty input');

  let qty = Number(input.value) || 0;

  qty = minus ? qty - 1 : qty + 1;
  if (qty < 0) qty = 0;

  await updateCartLine(key, qty);
});

//  Qty input change
document.addEventListener('change', async (e) => {
  const input = e.target.closest('.kuji-cart-line-qty input');
  if (!input) return;

  const lineEl = input.closest('.kuji-cart-line');
  if (!lineEl) return;

  const key = lineEl.dataset.key;
  let qty   = Number(input.value);
  if (isNaN(qty) || qty < 0) qty = 0;

  await updateCartLine(key, qty);
});


/* ------------------------------ Open/Close ------------------------------- */

function openKuji(sourceLabel = 'Cart', { prevTotal = null } = {}) {
  buildMainPopup();
  if (kujiPopupEl) {
    delete kujiPopupEl.dataset.kujiPopupVariant;
    applyPopupVariant();
  }
  if (!isDesignMode) updateKuji({ prevTotal }); // poll only if prevTotal given
  Cookies.set('kuji-seen', 'yes', 300);
  safeGAEvent('Open Popup', sourceLabel);
  safeMP('Popup Viewed', {
    Source: sourceLabel,
    Variable: kujiButtonText,
    Merchant: merchantHandle
  });
}

// Alias to support legacy inline onclick in your provided markup
window.openkuji = function(action, label, recheck) {
  // action is unused in the new flow; we keep it for compatibility
  openKuji(label || 'Cart', { recheck: Boolean(recheck) });
};

function openKujiPromo(label='Promo') {
  if (!kujiPromoEl) {
    kujiPromoEl = document.createElement('div');
    kujiPromoEl.id = 'kuji-promo-popup';
    kujiPromoEl.className = 'kuji-popup';
    kujiPromoEl.innerHTML = `
    <div class="kuji-popup-inner step-style-alt">
      <button type="button" class="close-kuji-popup-x" data-kuji-close="promo"></button>
      <div id="kuji-popup-content" class="popup-content">
        <div class="kuji-feature-img">
          <img class="kuji-popup-feature-img" src="${popupBg}" alt="">
          <div class="kuji-popup-content">
            <div class="kuji-relative">
              <div class="kuji-blur"></div>
              <h5 class="kuji-promo-title primary">Win your <b>entire cart</b></h5>
              <div class="hide-mobile">${RafGeneralInfo}</div>
            </div>
          </div>
          <h5 class="kuji-promo-title secondary"><b>Every ticket</b> wins instantly</h5>
        </div>
        <div class="show-mobile">${RafGeneralInfo}</div>
        ${RafSteps}${RafFooter}
      </div>
    </div>`;
    document.body.appendChild(kujiPromoEl);
  }
  fadeIn(kujiPromoEl, 'flex');
  Cookies.set('kuji-seen', 'yes', 300);
  safeGAEvent('Open Promo', label);
}

function openKujiInfo(label='Info') {
  if (!kujiInfoEl) {
    kujiInfoEl = document.createElement('div');
    kujiInfoEl.id = 'kuji-info-popup';
    kujiInfoEl.className = 'kuji-popup';
    kujiInfoEl.innerHTML = `
    <div class="kuji-popup-inner step-style-alt">
      <button type="button" class="close-kuji-popup-x" data-kuji-close="info"></button>
      <div id="kuji-popup-content" class="popup-content">
        <div class="kuji-feature-img">
          <img class="kuji-popup-feature-img" src="${popupBg}" alt="">
          <div class="kuji-popup-content"><h5>Every ticket wins</h5></div>
        </div>
        ${RafSteps}${RafFooter}
      </div>
    </div>`;
    document.body.appendChild(kujiInfoEl);
  }
  fadeIn(kujiInfoEl, 'flex');
  Cookies.set('kuji-seen', 'yes', 300);
  safeGAEvent('Open Info', label);
}

function openKujiHIW(label='HIW') {
  if (!kujiHIWEl) {
    kujiHIWEl = document.createElement('div');
    kujiHIWEl.id = 'kuji-hiw-popup';
    kujiHIWEl.className = 'kuji-popup';

    const multipleLineText = `<strong>${kujiXText}</strong> the kuji ticket value in store credit</p>`;
    kujiHIWEl.innerHTML = `
    <div class="kuji-popup-inner">
      <button type="button" class="close-kuji-popup-x" data-kuji-close="hiw"></button>
      <div class="popup-content">
        <div class="hiw-content-wrapper">
          <div class="hiw-content">
            <h3>How it works?</h3>
            <h3 class="second-title">WIN your cart.</h3>
            <table><tbody>
              <tr><td><span class="step">STEP 1</span></td><td><p>Add items to your cart and select the <strong>${kujiButtonText}</strong> button</p></td></tr>
              <tr><td><span class="step" style="background:#9948ff;">STEP 2</span></td><td><p>Purchase a kuji Ticket</p></td></tr>
              <tr><td><span class="step">STEP 3</span></td><td><p><strong>WIN</strong> your <strong>ENTIRE cart</strong> <em>OR</em> ${multipleLineText}</td></tr>
              <tr><td><span class="step">STEP 4</span></td><td><p>Finalise your purchase with your <strong>automatically applied</strong> kuji discount code</p></td></tr>
            </tbody></table>
          </div>
          <div class="raf-hiw-img">
            <img loading="lazy" width="968" height="1567" alt="kuji how it works" src="${RAF_ASSET_URL}merchant_hiw_popup_800x.png">
          </div>
        </div>
      </div>
    </div>`;
    document.body.appendChild(kujiHIWEl);
  }
  fadeIn(kujiHIWEl, 'flex');
  Cookies.set('kuji-seen', 'yes', 300);
  safeGAEvent('Open HIW', label);
}

function closeKuji(el) { fadeOut(el); Cookies.set('kuji-seen', 'yes', 300); }

/* --------------------------- Event Delegation ----------------------------- */

document.addEventListener('click', async (e) => {
  const buyTicket = e.target.closest('.kuji-buy-ticket');
  if (buyTicket) {
    trackMerchantAnalytics({
      step: 2,
      event: "popup_ticket_trigger",
      source: "popup_ticket_button",
      popupVariant: kujiPopupEl?.dataset.kujiPopupVariant || null,
    });
  }

  const addCartBtn = e.target.closest('.kuji-widget-cart button');
  if (addCartBtn) {
    trackMerchantAnalytics({
      step: 1,
      event: "popup_trigger",
      source: "cart_page_button",
    });

    // to do: might be a good idea to move the openKuji event here rather than added to the button
    //openKuji(trigger.dataset.kujiSource || 'Cart', { recheck:false });
  }

  const addProductBtn = e.target.closest('.kuji-add-product');
  if (addProductBtn) {
    e.preventDefault();
    const analyticsPayload = {
      step: 1,
      event: "popup_trigger",
      source: "product_page_button",
    };

    if (addProductBtn.dataset.kujiCtaReady === 'true') {
      analyticsPayload.ctaVariant = addProductBtn.dataset.kujiMessageVariant || null;
      analyticsPayload.ticketPrice = addProductBtn.dataset.kujiTicketPrice || null;
      analyticsPayload.productVariantId = addProductBtn.dataset.kujiVariantId || null;
    }

    trackMerchantAnalytics(analyticsPayload);

    addProductBtn.disabled = true;

    (async () => {
      // Snapshot current cart total BEFORE adding
      let prevTotal = 0;
      try {
        const before = await getCart(); // { total_price, ... }
        prevTotal = Number(before?.total_price || 0);
      } catch (err) {
        console.warn('Failed to read cart before add:', err);
      }

      // Find and submit nearby /cart/add form
      let el = addProductBtn;
      let productFormSubmit = null;
      while (el && el !== document.documentElement) {
        const forms = el.querySelectorAll('form[action="/cart/add"]');
        for (const form of forms) {
          const submit = form.querySelector([
            'button[type="submit"]',
            'button:not([type])',
            'input[type="submit"]',
            'button[name="add"]',
            '[type="submit"][name="add"]',
            '[data-add-to-cart]',
            '.product-form__submit',
            '.product-form-submit',
            '.add-to-cart',
            '[aria-label*="add to cart" i]',
            '[aria-label*="add-to-cart" i]'
          ].join(','));
          if (submit) { productFormSubmit = submit; break; }
        }
        if (productFormSubmit) break;
        el = el.parentElement;
      }

      productFormSubmit?.click();
      Cookies.set('kuji-added', 'yes', 1);

      // Open popup and start “wait until total changes” loop
      openKuji('Product', { prevTotal });

      addProductBtn.disabled = false;
    })();

    return;
  }

  const infoBtn = e.target.closest('.kuji-info-btn');
  if (infoBtn) {
    e.preventDefault();
    openKujiInfo('Popup');
    return;
  }

  const closeBtn = e.target.closest('[data-kuji-close]');
  if (closeBtn) {
    const which = closeBtn.getAttribute('data-kuji-close');
    if (which === 'main' && kujiPopupEl) closeKuji(kujiPopupEl);
    if (which === 'promo' && kujiPromoEl) closeKuji(kujiPromoEl);
    if (which === 'info' && kujiInfoEl) closeKuji(kujiInfoEl);
    if (which === 'hiw' && kujiHIWEl) closeKuji(kujiHIWEl);
    safeGAEvent('Close Popup', which);
    return;
  }

  const popup = e.target.classList.contains('kuji-popup') ? e.target : null;
  if (popup) {
    closeKuji(popup);
    safeGAEvent('Close Popup', 'External');
    return;
  }
});

/* --------------------------- Promo Triggers ------------------------------- */

(function promoTriggers() {
  if (!kujiStatus || Cookies.get('kuji-ab') !== '1' || isDesignMode) return;

  if (window.location.pathname === '/cart' && Cookies.get('kuji-added') === 'yes') {
    openKuji('Cart Page', { recheck:false });
    Cookies.delete('kuji-added');
  }

  if (Cookies.get('kuji-seen') !== 'yes' && typeof window.kuji_promo_timer !== 'undefined') {
    let popupTriggered = false;

    setTimeout(() => {
      if (!popupTriggered) {
        openKujiPromo('Timed');
        popupTriggered = true;
      }
    }, Number(window.kuji_promo_timer) || 22000);

    document.addEventListener('mouseleave', (event) => {
      if (popupTriggered) return;
      if (event.clientY <= 0 || event.clientX <= 0 || (event.clientX >= window.innerWidth || event.clientY >= window.innerHeight)) {
        openKujiPromo('Exit');
        popupTriggered = true;
      }
    });
  }

  if (kujiPreview.kuji_popup === 'true') {
    buildMainPopup();
    updateKuji('popup');
  }
})();


/* ------------------------- Widget Builder ------------------------- */

// “Empty” => no child elements (ignores whitespace text nodes)
function kujiIsEmpty(el) { return !el || el.childElementCount === 0; }

/**
 * Build the correct Kuji button markup into a widget container.
 * - For .kuji-widget-cart: renders cart CTA + "OR"
 * - For .kuji-widget-product: renders "OR" + product CTA, and matches width to add-to-cart submit
 */
function buildKujiBtn(widget) {
  if (!widget) return;

  const isProduct = widget.classList.contains('kuji-widget-product');
  const isCart    = widget.classList.contains('kuji-widget-cart');

  // Compute price text if provided for nicer display (optional; not required for your given markup)
  const productPriceCents = Number(widget.getAttribute('data-price') || 0);
  let info = null;
  if (productPriceCents) info = calculateTicket(productPriceCents);

  // --- CART WIDGET MARKUP (button then "OR") ---
  if (isCart) {
    if ( kujiIsEmpty(widget) ) {

      widget.innerHTML = `
    <div class="kuji-or-header">OR</div>
    <button class="kuji-trigger kuji-btn kuji-brand-btn" type="button" name="kuji-checkout" aria-label="kuji Checkout" onclick="openkuji('Open Popup','Cart',false)">
      <span>WIN YOUR CART</span> <span class="small-with">with</span>
      <img loading="lazy" width="28" height="12" src="${KujiLogoSmall}" alt="kuji logo">
    </button>`;
    }
  }

  // --- PRODUCT WIDGET MARKUP ("OR" then button) ---
  if (isProduct) {
    if ( kujiIsEmpty(widget) ) {

      widget.innerHTML = `
      <div class="kuji-or-header">OR</div>
      <button class="kuji-add-product kuji-btn kuji-brand-btn" type="button">
        <span class="buy-now">WIN IT NOW</span> <span class="small-with">with</span>
        <img loading="lazy" width="28" height="12" src="${KujiLogoSmall}" alt="kuji logo">
      </button>`;

    }
    const shopHandle = Shopify.shop.replace('.myshopify.com','')
    if (isDesignMode && !kujiStatus) {
      widget.insertAdjacentHTML(
        "beforeend",
        `
        <div class="kuji-status-message">
          <p><strong>Status: Draft</strong></p>
          <p>Kuji is only visible in the theme editor.
          <p><a href="https://admin.shopify.com/store/${shopHandle}/apps/kuji-now/app/install">Customise button</a>.</p>
        </div>
        `
      );
    }

    // For variable CTA testing:
    const productButton = widget.querySelector('.kuji-add-product');
    if (productButton) {
      if (productButton.dataset.kujiCtaInit !== 'true') {
        productButton.dataset.kujiCtaInit = 'true';
        updateProductButton(productButton);
        bindProductButtonEvents(productButton);
      }
    }
  }
  widget.style.visibility = 'visible';

  // Button last active tracking
  const now = Date.now();
  let update_active = true;

  if (window.kuji_last_active) {
    const lastActive = new Date(window.kuji_last_active).getTime();
    const oneHour = 60 * 60 * 1000;

    if (now - lastActive < oneHour) {
      update_active = false;
    }
  }

  if (update_active){
    fetch("/apps/kuji-proxy/last_active", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    });
  }
}


// Used for Variable Product Button CTA and Win for $X messaging:
function bindProductButtonEvents(button) {
  if (!button || button.dataset.kujiBound === 'true') return;
  button.dataset.kujiBound = 'true';

  const form = getNearestProductForm(button);
  const quantityInput = getNearestQuantityInput(button, form);

  const update = () => {
    window.requestAnimationFrame(() => {
      updateProductButton(button);
    });
  };

  // watch for  product form updates:
  if (form) {
    form.addEventListener('change', update);
    form.addEventListener('input', update);
  }

  if (quantityInput) {
    quantityInput.addEventListener('change', update);
    quantityInput.addEventListener('input', update);

    const quantityWrapper = quantityInput.closest(
      'quantity-input, .quantity, .quantity__input, .quantity-selector, .product-form__quantity'
    );

    if (quantityWrapper) {
      quantityWrapper.addEventListener('click', update);
    }
  }

  //compatibility with themes that emit variant:change
  document.addEventListener('variant:change', update);

  update();
}

/* Hydrate any empty Kuji widgets (both types) in a container */
function hydrateKujiWidgets(container = document) {
  //console.log('hydrating');
  container.querySelectorAll('.kuji-widget-cart, .kuji-widget-product').forEach((w) => {
    buildKujiBtn(w);
  });
}

function trackMerchantAnalytics({ step, event, source = null, ctaVariant = null, ticketPrice = null,
 productVariantId = null, popupVariant = null,
}) {
  try {
    fetch("/apps/kuji-proxy/analytics_event", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        step,
        event,
        source,
        ctaVariant,
        ticketPrice,
        productVariantId,
        popupVariant,
      }),
      keepalive: true,
    });
  } catch (_) {}
}

/* --------------------------- Check Kuji Status -------------------------- */

function shouldInitKuji() {
  if (kujiStatus && Cookies.get('kuji-ab') === '1') return true;
  if (Cookies.get('kuji-preview') === 'true' || kujiPreview?.kuji === 'true' || isDesignMode) return true;
  return false;
}

/* --------------------- Widget Observer  ---------------- */

/* Observers full dom changes - disabled in preference for a simple fetch/jQuery AJAX add to cart observer
// Checks for new Kuji widgets (eg. cart drawer updated from empty cart messaging)*/
function attachKujiWidgetObserver() {
  if (isDesignMode) return;

  const target = document.body || document.documentElement;
  if (!target) return;

  let raf = 0;
  const mo = new MutationObserver(() => {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(() => {
      raf = 0;
      refreshKujiWidgets(document);
    });
  });

  mo.observe(target, { childList: true, subtree: true });
}

/* Built to replace the observer which worked for add to cart, but we need this for quick shop popup too
//Check for ajax add to cart
function watchFetchAddToCart() {
  // Only watch once
  if (window.__kuji_cart_add_hooked) return;
  window.__kuji_cart_add_hooked = true;

  if (!window.fetch) return;

  const originalFetch = window.fetch;

  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);

    try {
      const url = typeof args[0] === 'string' ? args[0] : args[0]?.url;

      // check for '/cart/add' and '/cart/add.js'
      if (url && /\/cart\/add(\.js)?(\?|$)/.test(url)) {

        // Cart just went from empty → not empty
        requestAnimationFrame(() => hydrateKujiWidgets(document));
        // optional if theres issues with cart draw rendering:
        //requestAnimationFrame(() => {
          //requestAnimationFrame(() => hydrateKujiWidgets(document));
        //});
      }
    } catch (_) {}

    return response;
  };
}*/

function watchAjaxAddToCart () {
  if (window.__kuji_cart_add_xhr_hooked) return;
  window.__kuji_cart_add_xhr_hooked = true;

  const origOpen = XMLHttpRequest.prototype.open;
  const origSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    this.__kuji_url = url;
    return origOpen.call(this, method, url, ...rest);
  };

  XMLHttpRequest.prototype.send = function (...args) {
    this.addEventListener('load', () => {
      try {
        if (this.__kuji_url && /\/cart\/add(\.js)?(\?|$)/.test(this.__kuji_url)) {
          requestAnimationFrame(() => refreshKujiWidgets(document));
        }
      } catch (_) {}
    });

    return origSend.apply(this, args);
  };
}

/* --------------------------- Auto-inject Kuji widget -------------------------- */

/**
 * Add Kuji buttons to product ATC forms that don't have one.
 * Call on DOMContentLoaded + after known cart/product sections re-render.
 */
function autoAddKujiWidgets(container = document) {
  const forms = container.querySelectorAll('form[action]');

  forms.forEach((form) => {
    const action = (form.getAttribute('action') || '').trim().toLowerCase();

    // Match Shopify cart add endpoints ('/cart/add', '/cart/add.js' etc)
    if (!action.includes('/cart/add')) return;

    // Skip if form already contains any Kuji widget wrapper
    if (form.querySelector('.kuji-widget')) return;

    // Needs a submit control (avoid non-ATC forms)
    const submitBtn =
      form.querySelector('button[type="submit"], input[type="submit"]');
    if (!submitBtn) return;

    const styles = getComputedStyle(submitBtn);
    const borderRadius = styles.borderRadius.replace('px','') * 1;
    let radiusClass = '';
    if (borderRadius == 0) {
      radiusClass = ' kuji-square';
    } else if (borderRadius > 10) {
      radiusClass = ' kuji-round';
    }

    const widgetWrapper = document.createElement('div');
    widgetWrapper.className = `kuji-widget-product kuji-widget kuji-auto${radiusClass}`;

    // Insert immediately after submit if possible, else at end of form
    if (submitBtn.parentNode) {
      submitBtn.insertAdjacentElement('afterend', widgetWrapper);
    } else {
      form.appendChild(widgetWrapper);
    }

    try {
      buildKujiBtn(widgetWrapper);
    } catch (e) {
      console.warn('[Kuji] buildKujiBtn failed for auto wrapper', e);
    }
  });
}

function autoAddKujiCartDrawerWidget(container = document) {
  const shopHandle = String(Shopify?.shop || '')
    .trim()
    .toLowerCase()
    .replace(/\.myshopify\.com$/i, '');

  if (shopHandle !== 'b49zfy-ju') return;

  const checkoutSection = container.querySelector('.qsc2-drawer-footer__checkout__main-section');
  const targetParent = checkoutSection?.parentElement;
  if (!targetParent) return;

  const existingWidget = targetParent.querySelector(
    '.kuji-widget-cart.kuji-widget.kuji-square.kuji-below'
  );
  if (existingWidget) return;

  const widgetWrapper = document.createElement('div');
  widgetWrapper.className = 'kuji-widget-cart kuji-widget kuji-square kuji-below';
  targetParent.insertAdjacentElement('afterbegin', widgetWrapper);

  try {
    buildKujiBtn(widgetWrapper);
  } catch (error) {
    console.warn('[Kuji] buildKujiBtn failed for cart drawer widget', error);
  }
}

function refreshKujiWidgets(container = document) {
  autoAddKujiWidgets(container);
  autoAddKujiCartDrawerWidget(container);
  hydrateKujiWidgets(container);
}


/* --------------------------- INIT -------------------------- */

function init(container = document) {
  document.body.classList.add('kuji-enabled');

  if (window.kuji_btn_style != "" && window.kuji_btn_style != 'default'){
    document.body.classList.add(`kuji-btn-${window.kuji_btn_style}`);
  }

  refreshKujiWidgets(container);
}

/* --------------------------- Boot -------------------------- */

// Page load


document.addEventListener('DOMContentLoaded', () => {

  if (!shouldInitKuji()) return;

  init(document);
  attachKujiWidgetObserver();
  watchAjaxAddToCart();

  if (!isDesignMode) {
    setTimeout(() => {
      const ab = Cookies.get('kuji-ab');
      if (!ab) return;
      const val = (ab === '1') ? 'With kuji' : 'Without kuji';
      safeMP('A/B Split', { Action: 'Page View', Value: val, Merchant: merchantHandle });
      safeGAEvent('A/B Split', 'Visit');
    }, 1000);
  }
});

// Theme editor sections
document.addEventListener('shopify:section:load', (e) => {
  if (!shouldInitKuji()) return;
  init(e.target);
});

/*
// Reserved for later if needed
document.addEventListener('shopify:section:unload', () => {});
document.addEventListener('shopify:block:select', () => {});
document.addEventListener('shopify:block:deselect', () => {});
*/


/* ------------------------------ Public API -------------------------------- */

window.Kuji = window.Kuji || {
  open: (label='Cart', opts={}) => openKuji(label, opts),
  openInfo: openKujiInfo,
  openHIW: openKujiHIW
};


window.addEventListener("load", () => {
  const privacy = window.Shopify?.customerPrivacy;

  /*
  console.log("[Kuji consent on load]", {
    analyticsAllowed: privacy?.analyticsProcessingAllowed?.(),
    marketingAllowed: privacy?.marketingAllowed?.(),
    saleOfDataAllowed: privacy?.saleOfDataAllowed?.(),
  });*/
});
